import React from 'react'

interface BannerProps {
    title: string;
    description: string;
    status: 'success' | 'error' | 'warning';
    onClick?: () => void;
}
const Banner: React.FC<BannerProps> = ({ title, description, status, onClick }) => {
    return (
        <div className={`relative rounded-xl space-y-3 py-[16px] px-[16px] text-xs ${status === 'warning' ? 'bg-[rgba(255,251,230,1)]' : status === 'success' ? 'bg-[rgba(230,255,230,1)]' : 'bg-[rgba(255,230,230,1)]'}`}>
            <p className={`text-base ${status === 'warning' ? 'text-[rgb(0,0,0)]' : status === 'success' ? 'text-[#7eff7e]' : 'text-[rgba(255,0,0, 1)]'}`}>{title}</p>
            <p>{description}</p>
            {onClick &&
                <div
                    className={`cursor-pointer absolute top-3 right-3 ${status === 'warning' ? 'text-[rgb(255,206,43)]' : status === 'success' ? 'text-[#7eff7e]' : 'text-[rgba(255,0,0, 1)]'}`}
                    onClick={onClick}
                >
                    <i className="fas fa-times"></i>
                </div>
            }
        </div>
    )
}

export default Banner
